module.exports = __webpack_public_path__ + "img/mt_1.96867ab9.png";